(function(){
	
	// Import classes
	var	Button = springroll.pixi.Button,
		Container = PIXI.Container;

	/**
	*  Panel contains all of the visual elements for the cutscene state
	*  @class CutscenePanel
	*  @extends PIXI.Container
	*/
	var CutscenePanel = function()
	{
		Container.call(this);

		/**
		*  The skip button
		*  @property {springroll.pixi.Button} skipButton
		*/
		this.skipButton = null;
	};

	// The super prototype
	var s = Container.prototype;

	// Extend the base panel
	var p = CutscenePanel.prototype = Object.create(s);

	/**
	*  Setup the state, this happens on each state entering
	*  @method setup
	*/
	p.setup = function()
	{
		var fromImage = PIXI.Texture.fromImage;
		var buttonTextures =
		{
			up: fromImage("skipButton_up"),
			over: fromImage("skipButton_over"),
			down: fromImage("skipButton_down")
		};
		this.skipButton = new Button(buttonTextures);
		this.addChild(this.skipButton);
	};

	/**
	*  Clear the display
	*  @method teardown
	*/
	p.teardown = function()
	{
		if(!this.skipButton) return;
		
		this.skipButton.destroy();
		this.removeChild(this.skipButton);
		this.skipButton = null;
	};

	// Assign to namespace
	namespace('heist').CutscenePanel = CutscenePanel;
	
}());